import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { GridLayout } from 'components/form/layout';
import Title from 'components/Title';
import { PercentageFloatField, IntegerField } from 'components/form/field';

const ChildCare = ({ name }) => (
    <Fragment>
        <Title>Garde d&apos;enfants</Title>
        <GridLayout className="double condensed full-width">
            <PercentageFloatField
                name={`${name}.rate`}
                title="Taux de crédit (%)"
            />
            <IntegerField
                name={`${name}.ceil`}
                title="Plafond de credit par enfant à charge (€))"
            />
        </GridLayout>
    </Fragment>
);

ChildCare.propTypes = {
    name: PropTypes.string.isRequired,
};

export default ChildCare;
